import Header from "@/components/Header";
import Hero from "@/components/Hero";
import MeatsMarquee from "@/components/MeatsMarquee";
import MenuGrid from "@/components/MenuGrid";
import Drinks from "@/components/Drinks";
import HoursLocation from "@/components/HoursLocation";
import CateringForm from "@/components/CateringForm";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Header />
      <Hero />
      <MeatsMarquee />
      <MenuGrid />
      <Drinks />
      <HoursLocation />
      <CateringForm />
      <Footer />
    </main>
  );
}
